/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AgentOwnerAssignmentForm,
  AgentOwnerAssignmentForm$Outbound,
  AgentOwnerAssignmentForm$outboundSchema,
} from "../components/agentownerassignmentform.js";

export type TransferAgentSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type TransferAgentRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  agentOwnerAssignmentForm: AgentOwnerAssignmentForm;
};

/** @internal */
export type TransferAgentSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const TransferAgentSecurity$outboundSchema: z.ZodMiniType<
  TransferAgentSecurity$Outbound,
  TransferAgentSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function transferAgentSecurityToJSON(
  transferAgentSecurity: TransferAgentSecurity,
): string {
  return JSON.stringify(
    TransferAgentSecurity$outboundSchema.parse(transferAgentSecurity),
  );
}

/** @internal */
export type TransferAgentRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  AgentOwnerAssignmentForm: AgentOwnerAssignmentForm$Outbound;
};

/** @internal */
export const TransferAgentRequest$outboundSchema: z.ZodMiniType<
  TransferAgentRequest$Outbound,
  TransferAgentRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    agentOwnerAssignmentForm: AgentOwnerAssignmentForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      agentOwnerAssignmentForm: "AgentOwnerAssignmentForm",
    });
  }),
);

export function transferAgentRequestToJSON(
  transferAgentRequest: TransferAgentRequest,
): string {
  return JSON.stringify(
    TransferAgentRequest$outboundSchema.parse(transferAgentRequest),
  );
}
